import React, { useCallback } from 'react';

import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { TASK_NAME_MAX_WIDTH } from './PlanTaskTitle.consts';
import { useTaskLocale } from '../../hooks';
import { Task } from '../../types';

interface PlanTaskNameProps {
  task: Task;
  fontWeight?: number;
  maxWidth?: number | string;
}

const PlanTaskName = ({
  task,
  fontWeight = theme.typography.bodyMedium.fontWeight,
  maxWidth = TASK_NAME_MAX_WIDTH,
}: PlanTaskNameProps) => {
  const { T } = useTaskLocale();
  const taskName = task.name ?? T.translate('UNTITLED_TASK');

  const getTargetProps = useCallback(
    () => ({
      style: {
        color: theme.colors.charcoal900,
        ...theme.typography.bodyMedium,
        fontWeight,
        maxWidth,
      },
    }),
    [fontWeight, maxWidth],
  );

  return (
    <OverflowTooltip content={task.name} getTargetProps={getTargetProps}>
      {taskName}
    </OverflowTooltip>
  );
};

export default PlanTaskName;
